<template>
  <div :class="classnames">
    <drawer-hitzone @click="handleHitzoneClick">
      <drawer-control :isOpen="isOpen">
        <slot name="control" />
      </drawer-control>
    </drawer-hitzone>

    <drawer-area
      :contentHeight="contentHeight"
      :isOpen="isOpen"
      :minHeight="minHeight"
    >
      <drawer-content :isOpen="isOpen" @hasheight="handleHasHeight">
        <slot name="content" />
      </drawer-content>
    </drawer-area>
  </div>
</template>

<script>
  import DrawerArea from './DrawerArea'
  import DrawerContent from './DrawerContent'
  import DrawerControl from './DrawerControl'
  import DrawerHitzone from './DrawerHitzone'

  import { bem } from '@/mixins/bem.js'

  const namespace = 'drawer'

  const modifiers = {
    isOpen: 'is-open'
  }

  export default {
    name: 'Drawer',
    components: {
      'drawer-area': DrawerArea,
      'drawer-content': DrawerContent,
      'drawer-control': DrawerControl,
      'drawer-hitzone': DrawerHitzone
    },
    mixins: [ bem ],
    props: {
      lineClampHeight: {
        default: null,
        type: Number
      },
      minHeight: {
        default: 0,
        type: Number
      }
    },
    data: function () {
      return {
        contentHeight: 0,
        isOpen: false
      }
    },
    watch: {
      'lineClampHeight': function () {
        this.setState('contentHeight', this.lineClampHeight)
      }
    },
    created: function () {
      this.namespace = namespace
    },
    methods: {
      classnameModifiers: function () {
        const isOpen = this.isOpen && modifiers.isOpen

        return [ isOpen ]
      },
      close: function () {
        this.isOpen = false

        this.emitOpenState()
      },
      emitOpenState: function () {
        this.$emit('openchange', this.isOpen)
      },
      handleHasHeight: function (height) {
        this.contentHeight = height
      },
      handleHitzoneClick: function () {
        this.toggleOpenState()
      },
      open: function () {
        this.isOpen = true

        this.emitOpenState()
      },
      toggleOpenState: function () {
        const isOpen = this.isOpen

        if (isOpen) {
          this.close()
        } else {
          this.open()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/Drawer/Drawer.vue